<ng-container *ngIf="{
    row: columnData | async
  } as $">
    <span
    class="flex text-600 font-normal text-xs ">{{memberSince($.row.client_since).exact}}<span class="mx-2"><member-crown [columnData]="columnData"></member-crown></span></span>
    
</ng-container>
